var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 122,
    viewBox: "0 0 79 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 78,
    height: 121,
    rx: 5.5,
    fill: "white",
    stroke: "#E9E9E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 55,
    height: 2,
    fill: "#4A4A68"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 23.5,
    width: 57,
    height: 11,
    rx: 2.5,
    stroke: "#E9E9E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 50,
    width: 64,
    height: 9,
    rx: 3,
    fill: "#F2F3F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 63,
    width: 64,
    height: 9,
    rx: 3,
    fill: "#F2F3F4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "customizable",
    x: 8,
    y: 84,
    width: 64,
    height: 9,
    rx: 3,
    fill: "#194590"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 42.5H70",
    stroke: "#E9E9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "customizable",
    d: "M9 76H47",
    stroke: "#194590",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 89H48",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 101H65",
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 111H46",
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "customizable",
    d: "M47 111H59",
    stroke: "#194590",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "customizable",
    x: 15,
    y: 99,
    width: 4,
    height: 4,
    fill: "#194590"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPreview);
export default __webpack_public_path__ + "static/media/FormPreview.547bc3644aadeeb0eaa8da0ae70a0708.svg";
export { ForwardRef as ReactComponent };